const SubsriberType = Object.freeze({
  Host: { id: 0, name: "Host" },
  Tenant: { id: 1, name: "Tenant" },
});

export default SubsriberType;
